<div class="containerPhoto" #photoContainer>
  <div class="box" (click)="clickPoint($event)" [ngStyle]="{'width.px':this.widthPhoto,'height.px':this.heightPhoto}">
    @if (selectedPoint) {
      <div class="ball" #ball
        [ngStyle]="{'margin-top.px':this.yInPx,'margin-left.px':this.xInPx,'transition': transition}"
        cdkDragBoundary=".box"
      cdkDrag (cdkDragStarted)="startDrag()" (cdkDragEnded)="endDrag()"></div>
    }
    @if (!selectedPoint) {
      <div class="window"
        [ngStyle]="{'width.px':widthText,'margin-top.px':this.yText,'margin-left.px':this.xText,'font-size.px':this.sizeText}">
        KLIKNIJ ABY USTAWIĆ PUNKT CENTRALNY
      </div>
    }
    <img [src]="url" alt="photo">
  </div>
  @if (!(isPhonePortrait$ | async)) {
    <div class="box-button" [ngStyle]="{'width.px':this.widthPhoto,'height.px':this.heightPhoto}"
      >
      <lib-button (clicked)="openFullPhotoSelection()" lg>WYBIERZ INNY PLIK</lib-button>
    </div>
  }
</div>
@if (!(isPhonePortrait$ | async)) {
  <ng-template *ngTemplateOutlet="preview"></ng-template>
}
<ng-template #preview>
  <div class="containerScreen">
    @if (isBooking) {
      <lib-screen-square
        [url]="url"
        [imageSize]="imageSize"
      [point]="{x: x, y: y}"></lib-screen-square>
    }
    @if (!isBooking) {
      <lib-screen-laptop
        [url]="url"
        [imageSize]="imageSize"
      [point]="{x: x, y: y}"></lib-screen-laptop>
    }
    @if (!isBooking) {
      <lib-screen-ipad
        [url]="url"
        [imageSize]="imageSize"
      [point]="{x: x, y: y}"></lib-screen-ipad>
    }
    @if (!isBooking) {
      <lib-screen-iphone
        [url]="url"
        [imageSize]="imageSize"
      [point]="{x: x, y: y}"></lib-screen-iphone>
    }
  </div>
  <div class="cancel">
    @if ((isPhonePortrait$ | async)) {
      <lib-button fullscreen-close lg>ZAMKNIJ</lib-button>
    }
  </div>
</ng-template>
@if (!(isPhonePortrait$ | async)) {
  <div class="laptop-button">
    <lib-button (clicked)="save()" lg>ZAPISZ</lib-button>
  </div>
}
@if ((isPhonePortrait$ | async)) {
  <div class="phone-button">
    <button mat-icon-button (click)="openFullPhotoSelection()">
      <mat-icon>collections</mat-icon>
    </button>
    <lib-button (clicked)="openFull()" lg>PODGLĄD</lib-button>
    <button mat-icon-button>
      <mat-icon (click)="save()">done</mat-icon>
    </button>
  </div>
}
<!--[routerLink]="['/photo-selection']"-->
